import { Document, DocumentFilterTypeEnum, DocumentSortFieldEnum, DocumentSortOrderEnum } from "@/app/graphql/codegen";

interface DocumentFilterOptions {
    searchTerm?: string;
    type?: string; // legacy, unused for lexicon
    jurisdiction?: string;
    sortField?: DocumentSortFieldEnum;
    sortOrder?: DocumentSortOrderEnum;
}

export function filterAndSortDocuments(documents: Document[], options: DocumentFilterOptions): Document[] {
    const { searchTerm = "", type, jurisdiction, sortField, sortOrder } = options;
    
    // First filter the documents
    let filtered = documents;
    
    // Legacy "type" filter kept for compatibility with chat sidebar (still passed to backend)
    if (type && type !== DocumentFilterTypeEnum.All) {
        filtered = filtered.filter(doc => doc.category === type);
    }
    
    // New jurisdiction filter (client-side only)
    if (jurisdiction && jurisdiction !== "all") {
        filtered = filtered.filter(doc => {
            const docJur = (doc as any).jurisdiction || (doc.metadata as any)?.jurisdiction;
            // Normalize: treat "DE" and "GER" as equivalent
            const normalizedDocJur = docJur === "GER" ? "DE" : docJur;
            const normalizedJurisdiction = jurisdiction === "GER" ? "DE" : jurisdiction;
            return normalizedDocJur === normalizedJurisdiction;
        });
    }
    
    if (searchTerm) {
        const searchLower = searchTerm.toLowerCase();
        filtered = filtered.filter(doc => 
            (doc.name?.toLowerCase().includes(searchLower) || 
             doc.reference?.toLowerCase().includes(searchLower) ||
             doc.description?.toLowerCase().includes(searchLower) ||
             (doc as any).hoverTitle?.toLowerCase().includes(searchLower))
        );
    }
    
    // Then sort them
    if (sortField) {
        filtered = [...filtered].sort((a, b) => {
            let comparison = 0;
            
            switch (sortField) {
                case DocumentSortFieldEnum.Title:
                    comparison = (a.name || "").localeCompare(b.name || "");
                    break;
                    
                case DocumentSortFieldEnum.Date:
                    // Assuming there's a date field to sort by - modify as needed
                    comparison = new Date(a.updatedAt || "").getTime() - 
                                new Date(b.updatedAt || "").getTime();
                    break;
                    
                case DocumentSortFieldEnum.Size:
                    // Sort by size (tokens or other measure)
                    comparison = (a.rootContentNode?.sizeInTokens || 0) - 
                                (b.rootContentNode?.sizeInTokens || 0);
                    break;
                    
                default:
                    break;
            }
            
            // Apply sort order
            return sortOrder === DocumentSortOrderEnum.Desc ? -comparison : comparison;
        });
    }
    
    return filtered;
}